module.exports = __webpack_public_path__ + "static/media/IELTS-GeneralTrainingReading-GapFill.b260309f.png";